const WarningIconVerification = ({ className, size = 26 }) => (
  <div className={className}>
    <svg width={size} height={size}viewBox='0 0 24 24' fill='none'>
      <path d='M12 2L2 20h20L12 2z' stroke='white' strokeWidth='2' strokeLinejoin='round' />
      <path d='M12 9v4M12 17h.01' stroke='white' strokeWidth='2.5' strokeLinecap='round' />
    </svg>
  </div>
);

export default WarningIconVerification;
